/**
 * NOTE: if there are multiple experiments enabled - the this.analyticsIdentifyBreadcrumbs will be overridden
 * refer for more info to:
 * http://stackoverflow.com/questions/25088218/running-multiple-experiments-on-google-analytics-experiments-from-the-same-page
 */

/* global cxApi:readonly ga:readonly */
import app from 'app';
import Analytics from 'c/WtAnalytics';
import Marionette from 'backbone.marionette';

app.namespace.Controller.Experiment = Marionette.Object.extend({
  // @analytics_breadcrumbs
  analyticsIdentifyBreadcrumbs: {},

  initialize: function () {
    // if some analytics api is missing - disable all experiments
    const apiPresent = _.every(['cxApi', 'ga'], function (api) {
      return _.isDefined(window[api]);
    });
    if (!apiPresent) {
      // app.doctorController.report('Google experiment/analytics blocked by client');
      _.each(this._experiments, (experiment) => {
        if (experiment.type !== 'rnd') {
          experiment.enabled = false;
        }
      });
    }

    // @experiments_configuration
    _.each(
      this._experiments,
      function (experiment) {
        if (experiment.enabled) {
          experiment.initialize();

          if (experiment.relevant && experiment.type !== 'rnd') {
            let eventLabel = 'null';

            if (_.isDefined(experiment.variations[experiment.variation])) {
              eventLabel =
                experiment.variations[experiment.variation].eventLabel;
            }

            $.extend(this.analyticsIdentifyBreadcrumbs, {
              Variation: eventLabel,
            });
          }
        }
      }.bind(this)
    );
  },

  /**
   * return true if any experiment is enabled and relevant
   * @return {boolean}
   */
  inProgress: function () {
    return _.some(this._experiments, { enabled: true, relevant: true });
  },

  /**
   * If @test_plan is disabled or not relevant
   *  - default action will be issued, meaning @test_specific function will return false
   */
  _experiments: {
    /*
    example: {
        // @experimentId (unused - here for reference only)
        id: null,
        // {const Boolean} managed by experiment maintainer to enable or disable test on client-side
        // between releases
        enabled: false,
        // {Boolean} @experiment_relevancy
        relevant: null,
        // @test_variations, index should mirror google analytics AB test cxApi behaviour
        variation: 0,
        variations: [
            // @custom event label
            {eventLabel: 'Original'},
            {eventLabel: 'My experiment was triggered...'}
        ],
        initialize: $.noop
    },
    */
    // @test_plan
    searchEditorialAndCreative: {
      id: null,
      name: 'searchEditorialAndCreative',
      enabled: true,
      relevant: false,
      variation: null,
      variations: [
        { eventLabel: 'searchEditorialAndCreative Off' },
        { eventLabel: 'searchEditorialAndCreative On' },
      ],
      initialize: function () {
        if (!this.enabled) {
          return;
        }
        this.relevant = app.rootStore.getters['user/type'].CUSTOMER; // || app.rootStore.getters['user/type'].WOCHIT_INTERNAL;
        if (this.relevant) {
          // the current user programmers contains at least on programmer from the test list
          if (
            !_.isEmpty(
              _.intersection(
                _.map(app.programmers.models, 'id'),
                [
                  294912, 17596419, 4751378, 4915202, 21528577, 3342344,
                  3407876, 8978442,
                ]
              )
            )
          ) {
            this.variation = 1;
          } else {
            this.variation = 1;
          }
        }
      },
    },
    // @test_plan
    startPage: {
      id: null,
      name: 'startpage',
      enabled: true,
      relevant: null,
      variation: null,
      variations: [
        { eventLabel: 'Start from Original' },
        { eventLabel: 'Start from TimeLine' },
      ],

      initialize: function () {
        if (!this.enabled) {
          return;
        }
        this.id = app.rootStore.getters['user/box'].isProd()
          ? 'Esr3VSKXSwS11wn1i3ZmmA'
          : 'KmSEB3WCRdm6T_Y9Y5vpTw';
        this.relevant = !!app.rootStore.getters['user/type'].INDIVIDUAL_CREATOR;
        if (this.relevant) {
          try {
            const chosenVariation = cxApi.getChosenVariation();

            if (cxApi.NOT_PARTICIPATING === chosenVariation) {
              this.variation = null;
            } else if (cxApi.NO_CHOSEN_VARIATION === chosenVariation) {
              if (app.rootStore.getters['user/isFirstLogin']) {
                this.variation = cxApi.chooseVariation();
              } else {
                this.variation = null;
              }
            } else {
              this.variation = chosenVariation;
            }

            Analytics.trigger('analytics:abtesting:' + this.name, {
              Variation: this.variation,
            });

            let eventLabel = 'null';
            if (_.isDefined(this.variations[this.variation])) {
              eventLabel = this.variations[this.variation].eventLabel;
            }

            ga('send', {
              hitType: 'event',
              eventCategory: 'ABTEST',
              eventAction: 'Test Start Page',
              eventLabel: eventLabel,
            });
          } catch (bug) {
            app.doctorController.report(
              'Problem with Google Experiment named: ' + this.name,
              bug
            );
            console.error(bug.toString());
          }
        }
      },
    },
  },

  /**
   * @test_specific
   * @return {Boolean}
   */
  startFromTimeline: function () {
    return this._experiments.startPage.variation === 1;
  },

  searchEditorialAndCreative: function () {
    return this._experiments.searchEditorialAndCreative.variation === 1;
  },

  isEnabled: function (experiment) {
    if (_.isDefined(this[experiment]) && _.isFunction(this[experiment])) {
      return this[experiment]();
    }
    return false;
  },
});
